'use strict';
/* global Promise */

var showMoreResult = true;
var searchBase = require('base/search/search');
var common = require('../common');
var breakpoints = require('../components/breakpoints');
var customFilterButtons = require('../components/customFilterButtons');
var filterCarousel = require('../components/filterCarousel');
var utils = require('../utils');
var debounce = require('lodash/debounce');

common.lazyLoad();

var isMobile = function () {
    return window.innerWidth < 992;
};

var isDesktop = function () {
    return window.innerWidth > 991;
};

var loadFlag = true;
var refinementSelected = false;
var $refinementBar;
var $mobileRefinementBar;
var headerHeightNew = $('header').outerHeight();
var backButtonFlag = true;
var isPageDesigner = $('#isPageDesigner').length > 0;
var pageDesignerId = isPageDesigner && $('.storepage').length ? $('.storepage').get(0).id : null;
var globalHiddenFilterTagsContainerWidth = 0;
var previousSelectedFilters = []; // Track previously selected filters for removal announcements

// get width of hidden filter tag count container
function getHiddenFilterTagsContainerWidth() {
    if (!globalHiddenFilterTagsContainerWidth || globalHiddenFilterTagsContainerWidth <= 0) {
        var $hiddenFilterTagsContainer = $('.filter-tags-container-desktop .hidden-filter-tags-count-container');

        $hiddenFilterTagsContainer.css('visibility', 'hidden');
        $hiddenFilterTagsContainer.removeClass('d-none');

        globalHiddenFilterTagsContainerWidth = $hiddenFilterTagsContainer.width();

        $hiddenFilterTagsContainer.addClass('d-none');
        $hiddenFilterTagsContainer.css('visibility', 'visible');
    }

    return globalHiddenFilterTagsContainerWidth;
}

function syncPlpSeoUrl(urlValue) {
    var rawUrl = urlValue && urlValue.href ? urlValue.href : urlValue;
    var absoluteUrl;

    try {
        absoluteUrl = new URL(rawUrl || window.location.href, window.location.origin).toString();
    } catch (e) {
        absoluteUrl = window.location.href;
    }

    var canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
        canonicalLink.href = absoluteUrl;
    }

    var ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
        ogUrl.setAttribute('content', absoluteUrl);
    }
}

function replaceUrlAndSync(urlValue) {
    window.history.replaceState(null, null, urlValue);
    syncPlpSeoUrl(urlValue);
}

// append/set params to url
function setURLSearchParam(key, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.pushState({ path: url.href }, '', url.href);
    syncPlpSeoUrl(url.href);
}

// scroll window when apply filter or sort
function scrollOnApplyRefinement() {
    var $plpHero = $('.plp-hero').find('.content-asset');
    var scrollOffset = $('.header-banner').outerHeight() + $('.main-menu').outerHeight() + $plpHero.outerHeight();
    if ($plpHero.length) {
        var plpHeroOffset = $plpHero.offset().top;
        var plpHeroHeight = $plpHero.outerHeight();

        if (window.innerWidth < 1023) {
            $('html, body').scrollTop((plpHeroOffset + plpHeroHeight + 5) - headerHeightNew);
        } else {
            $('html, body').scrollTop(scrollOffset + 7);
        }
    } else {
        $('html, body').animate({ scrollTop: 0 }, 0);
    }
}

function handleSortPrefix(value) {
    var $sortPrefix = $('.sort-dropdown .sort-prefix');
    var sortText = $sortPrefix.text().trim();
    if (value && value.length > 0) {
        if (sortText.indexOf(':') < 0) {
            $sortPrefix.addClass('mr-1').text(sortText + ':');
        }
    } else {
        $sortPrefix.removeClass('mr-1').text(sortText.replace(/:/g, ''));
    }
}

// get/update srule
function updateSrule() {
    var urlParams = new URL(window.location.href).searchParams;
    var selectedSort = encodeURIComponent(urlParams.get('srule'));
    if (selectedSort) {
        var sortText = 'srule=' + selectedSort;
        var $customDropdown = $('.custom-dropdown');
        handleSortPrefix();
        $customDropdown.find('li').each(function () {
            if ($(this).attr('value') && $(this).attr('value').indexOf(sortText) > -1) {
                $(this).attr('selected', '');
                var text = $customDropdown.find('li[selected]').text();
                $customDropdown.find('.display-value').removeClass('d-none');
                $customDropdown.find('.display-value').text(text);
                handleSortPrefix(text);
            }
        });
    }
}

// set filterPanelOpen param
function getFilterPanelParam() {
    var filterPanelOpen;
    if ($('.refinements-sidebar').hasClass('animate') && isDesktop()) {
        filterPanelOpen = false;
        setURLSearchParam('filterPanelOpen', filterPanelOpen);
    } else {
        setURLSearchParam('filterPanelOpen', true);
    }
}

// mobile sticky apply/close/clear buttons
function mobileFilterPanelControls() {
    var filterCount = $('.refinement-panel').find('label, button').find('span.selected').length;
    if (filterCount > 0) {
        $('.refine-apply').removeClass('d-none');
        $('.refine-close').addClass('d-none');
        $('.refinement-panel .filter-count').removeClass('d-none');
    } else {
        $('.refine-close').removeClass('d-none');
        $('.refine-apply').addClass('d-none');
        $('.refinement-panel .filter-count').addClass('d-none');
    }
    $('.refinement-panel .filter-count').text('(' + filterCount + ')');
}

function hideSingleValueFromRefinement() {
    $('.refinement-bar .refinement, #mobileRefinementBar .refinement').each(function () {
        var refinementCount = $(this).find('ul li').length;
        $(this).toggleClass('d-none', refinementCount < 2);
    });
}

function setCustomSelectWidth() {
    if (isDesktop()) {
        var urlParams = new URL(window.location.href).searchParams;
        var selectedSort = urlParams.get('srule');
        if (selectedSort) {
            $('.custom-select .sort-text').removeAttr('selected');
            $('.custom-select').find('option[selected]').each(function () {
                $(this).prop('selected', true);
            });
        } else {
            $('.custom-select .sort-text').prop('selected');
        }
        $('#width_tmp_option').html($('.custom-select option:selected').text());
        $('.custom-select').width($('#width_tmp_select').width());
    }
}

/**
 * PM-1464 : Remove Broken Logos in Onsite Search
**/
function reloadLogoImages() {
    $('.collegiate-logo-attribute img').each(function () {
        // set the source attribute again to prevent the server from caching the error to invoke onerror handler each time
        $(this).attr('src', $(this).attr('src'));
    });
    $('.collegiate-logo-attribute img').on('error', function () {
        $(this).parents('li.collegiate-logo-attribute').remove();
    });
}
function resetSort() {
    $('.custom-select').change(function () {
        var $selectList = $(this);
        var $selectedOption = $selectList.children('[value="' + this.value + '"]')
            .attr('selected', true);
        var selectedIndex = $selectedOption.index();

        var $nonSelectedOptions = $selectList.children().not($selectedOption)
            .remove()
            .attr('selected', false);

        // Reset and calculate new fixed width having only selected option as a child
        $selectList.width('auto').width($selectList.width() + 19);

        // Add options back and put selected option in the right place on the list
        $selectedOption.remove();
        $selectList.append($nonSelectedOptions);
        if (selectedIndex >= $nonSelectedOptions.length) {
            $selectList.append($selectedOption);
        } else {
            $selectList.children().eq(selectedIndex).before($selectedOption);
        }
    });
}

function initFilterTags() {
    var filterTagsSelector = '.filter-tags-container-mobile .filter-tags-list';
    var allSlidesWidths = 0;
    $(filterTagsSelector).find('.filter-tag, .filter-tags-reset').each(function (index, tag) {
        allSlidesWidths += $(tag).outerWidth();
    });
    if ($(window).width() <= 991 && allSlidesWidths > $(filterTagsSelector).outerWidth()) {
        $(filterTagsSelector).slick({
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            variableWidth: true,
            slidesToScroll: 1,
            arrows: true,
            draggable: true,
            touchMove: true,
            swipeToSlide: true,
            swipe: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });

        $(filterTagsSelector).slick('slickFilter', function (arg1, arg2) {
            return $(arg2).find('.hidden-filter-tags-count-container.d-none').length === 0;
        });

        $(filterTagsSelector).on('afterChange', function () {
            var $lastFilterTag = $(filterTagsSelector).find('.filter-tag').last();
            var lastFilterTagPosition = $lastFilterTag.offset().left + $lastFilterTag.outerWidth();
            var disableNextArrow = lastFilterTagPosition <= $(window).width();
            $(filterTagsSelector)
                .find('.slick-next.slick-arrow')
                .toggleClass('slick-disabled', disableNextArrow)
                .attr('aria-disabled', disableNextArrow);
        });
    } else if ($(filterTagsSelector).hasClass('slick-initialized')) {
        $(filterTagsSelector).slick('unslick');
    }
}

function initPLPTilesToShowAndSPLPGridParamsSessionStorage() {
    sessionStorage.setItem('splpGridParams', '');
    sessionStorage.setItem('plpTilesToShow', '');
    sessionStorage.setItem('plpTilesToShowDesktop', '');
    sessionStorage.setItem('plpTilesToShowTablet', '');
    sessionStorage.setItem('plpTilesToShowMobile', '');

    var urlParams = new URL(window.location.href).searchParams;
    var selectedSort = urlParams.get('srule');
    var selectedFilter = urlParams.toString().indexOf('prefv') > -1;

    var $splitProductGrids = $('.product-split-grid');
    if (!$splitProductGrids || $splitProductGrids.length === 0) {
        var $gridFooter = $('.grid-footer');
        if ($gridFooter && $gridFooter.length > 0) {
            var defaultPageSize = $gridFooter.data('default-page-size');
            if ((selectedSort || selectedFilter) && defaultPageSize) {
                sessionStorage.setItem('plpTilesToShow', defaultPageSize);
                sessionStorage.setItem('plpTilesToShowDesktop', defaultPageSize);
                sessionStorage.setItem('plpTilesToShowTablet', defaultPageSize);
                sessionStorage.setItem('plpTilesToShowMobile', defaultPageSize);
            }
        }
    } else if ($splitProductGrids && $splitProductGrids.length > 0) {
        var splitPLPGridParams = '';
        $splitProductGrids.each(function () {
            var $splpGridFooter = $(this).find('.grid-footer');
            var categoryId = $(this).data('category-id');
            if ($splpGridFooter && $splpGridFooter.length > 0) {
                var defaultSPLPSize = $splpGridFooter.data('default-page-size');
                if ((selectedSort || selectedFilter) && defaultSPLPSize) {
                    splitPLPGridParams += categoryId + ':' + defaultSPLPSize + '|' + defaultSPLPSize + '|' + defaultSPLPSize + '|' + defaultSPLPSize + ';';
                    sessionStorage.setItem('splpGridParams', splitPLPGridParams);
                }
            }
        });
    }
}

$(document).ready(function () {
    $('.lazy').unveil();
    resetSort();
    reloadLogoImages();
    initFilterTags();
    filterCarousel.init();
    customFilterButtons.handleFilterButtonsDisable();
    customFilterButtons.updateFilterButtonStates();

    initPLPTilesToShowAndSPLPGridParamsSessionStorage();

    // Initialize previousSelectedFilters on page load to support NVDA announcements
    // This ensures the screen reader logic works even when filter panel starts closed
    $('.filter-tags-container-desktop .sr-only.selected-assistive-text').each(function () {
        var text = $(this).text().trim();
        var cleanedText = text.replace(/^selected\s*/i, '').trim();
        cleanedText = cleanedText.replace(/^currently refined by\s*/i, '').trim();
        if (cleanedText) {
            previousSelectedFilters.push(cleanedText);
        }
    });
});
/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {string} placeholderURL - placeholder image URL for jquery-lazy
 * @param {string} lazyErrorImage - ErrorImage image URL for jquery-lazy
 */

/**
 * injects page designer grid regions into product grid
 * @param {string} response - html response from Search-UpdateGrid
 * @return {jquery} - updated response with injected grid regions
 */
function injectRenderedGridRegions(response) {
    var updatedResponse = null;
    var $gridRegionsToRender = $('#pd-gridRegionsToRender');
    if (response && $gridRegionsToRender && $gridRegionsToRender.length) {
        updatedResponse = $(response).map(function () {
            if (this.classList && this.classList.length) {
                for (let i = 0; i < this.classList.length; i++) {
                    var className = this.classList[i];

                    if (className && className.includes('pd-gridRegion')) {
                        var selectorClass = className;

                        var $gridRegionToRender = $gridRegionsToRender.find('.' + selectorClass);
                        if (!($gridRegionToRender && $gridRegionToRender.length > 0) && selectorClass.includes('pd-gridRegionLast')) {
                            selectorClass = selectorClass.replace('-desktop', '').replace('-tablet', '').replace('-mobile', ''); // does not match because they have the breakpoint classes in grid regions to render
                            $gridRegionToRender = $gridRegionsToRender.find('.' + selectorClass);
                        }

                        if ($gridRegionToRender && $gridRegionToRender.length) {
                            var gridRegion = $gridRegionToRender.get(0);
                            if (gridRegion) {
                                this.innerHTML = gridRegion.innerHTML;
                            }
                        }
                    } else if (className && (className.includes('product-grid') || className.includes('product-split-grid'))) {
                        $(this).find('[class*="pd-gridRegion"').each(function () {
                            if (this.classList && this.classList.length) {
                                for (let j = 0; j < this.classList.length; j++) {
                                    var childClassName = this.classList[j];

                                    if (childClassName && childClassName.includes('pd-gridRegion')) {
                                        var childSelectorClass = childClassName;

                                        var $childGridRegionToRender = $gridRegionsToRender.find('.' + childSelectorClass);
                                        if (!($childGridRegionToRender && $childGridRegionToRender.length > 0) && childSelectorClass.includes('pd-gridRegionLast')) {
                                            childSelectorClass = childSelectorClass.replace('-desktop', '').replace('-tablet', '').replace('-mobile', '');
                                            $childGridRegionToRender = $gridRegionsToRender.find('.' + childSelectorClass);
                                        }

                                        if ($childGridRegionToRender && $childGridRegionToRender.length) {
                                            var childGridRegion = $childGridRegionToRender.get(0);
                                            if (childGridRegion) {
                                                this.innerHTML = childGridRegion.innerHTML;
                                            }
                                        }
                                    }
                                }
                            }
                        });

                        $(this).append($gridRegionsToRender);
                    }
                }
            }
            return this;
        });
    }
    return updatedResponse;
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);

    var $updatedResponse = null;
    if (selector === '.product-grid') {
        $updatedResponse = injectRenderedGridRegions($updates);
    }
    if ($updatedResponse) {
        $(selector).empty().html($updatedResponse.html());
    } else {
        $(selector).empty().html($updates.html());
    }
}

function isFilterTagBarSticky() {
    var isSticky = false;
    var $header = $('header');
    var $filterNavWrapper = $('.filter-nav-wrapper');

    if ($filterNavWrapper.length > 0) {
        var headerTop = $header.offset().top;
        var headerHeight = $header.outerHeight();
        var $filterNavWrapperTop = $filterNavWrapper.offset().top;
        isSticky = (headerTop + headerHeight + 1) > $filterNavWrapperTop;
    }

    return isSticky;
}

function updateStickyFilterTags() {
    var $hiddenFilterTagsContainerLocal = $('.hidden-filter-tags-count-container');
    var $filterTagsList = $('.filter-tags-container-desktop .filter-tags-list');
    var filterTagsListGap = 0;
    var $filterTags;

    if ($filterTagsList && $filterTagsList.length) {
        filterTagsListGap = $filterTagsList.css('gap');
        filterTagsListGap = filterTagsListGap ? parseFloat(filterTagsListGap) : 0;
        $filterTags = $filterTagsList.find('.filter-tag, .filter-tags-reset');
    }

    if (!($filterTags && $filterTags.length)) {
        return;
    }

    var isSticky = isFilterTagBarSticky();
    if (isSticky) {
        var filterTagsListWidth = $filterTagsList.width();
        var filterTagsTotalWidth = 0;
        var hiddenFilterTagsCount = 0;
        var hiddenFilterTagsContainerWidth = getHiddenFilterTagsContainerWidth();

        $filterTags.removeClass('d-none');
        $filterTags.each(function (index) {
            var filterTagWidth = $(this).width();
            var isLast = $filterTags.length === (index + 1);

            var updatedFilterTagsTotalWidth = filterTagsTotalWidth + filterTagWidth;
            if (!isLast) {
                updatedFilterTagsTotalWidth += filterTagsListGap + hiddenFilterTagsContainerWidth;
            }

            if (updatedFilterTagsTotalWidth > filterTagsListWidth) {
                filterTagsTotalWidth = updatedFilterTagsTotalWidth;
                hiddenFilterTagsCount += 1;
                $(this).addClass('d-none');
            } else {
                filterTagsTotalWidth += filterTagWidth;
            }

            filterTagsTotalWidth += filterTagsListGap;
        });

        if (hiddenFilterTagsCount > 0) {
            $hiddenFilterTagsContainerLocal.find('.hidden-filter-tags-count').text(hiddenFilterTagsCount);
            $hiddenFilterTagsContainerLocal.removeClass('d-none');
        } else {
            $hiddenFilterTagsContainerLocal.find('.hidden-filter-tags-count').text(0);
            $hiddenFilterTagsContainerLocal.addClass('d-none');
        }
    } else {
        $filterTags.removeClass('d-none');
        $hiddenFilterTagsContainerLocal.addClass('d-none');
    }
}

var debounceUpdateStickyFilterTags = debounce(updateStickyFilterTags, 200);

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @return {undefined}
 */
function handleRefinements() {
    $refinementBar.find('.refinement.active').each(function () {
        $(this).removeClass('active');
        $('#refinementBar')
            .find('.' + $(this)[0].className.replace(/ /g, '.'))
            .addClass('active')
            .find('.js_refinement-heading')
            .attr('aria-expanded', 'true');
    });

    $mobileRefinementBar.find('.refinement.active').each(function () {
        $(this).removeClass('active');
        $('#mobileRefinementBar')
            .find('.' + $(this)[0].className.replace(/ /g, '.'))
            .addClass('active')
            .find('.js_refinement-heading')
            .attr('aria-expanded', 'true');
    });

    // Remove from memory
    $refinementBar = null;
    $mobileRefinementBar = null;
}

/**
 * Shows or hides reset button + reinitializes tag carousel on mobile
 * @param {Object} $results - jQuery DOM element
 */
function handleFilterTags($results) {
    // Now update the DOM first
    $('.filter-tags-container').empty().html($results.find('.filter-tags-container').html());
    $('.filter-tags-list').toggleClass('d-none', $results.find('.filter-tags-container').find('.filter-tag').length === 0);

    // Get all current filter texts AFTER updating the DOM (use only desktop container to avoid duplicates)
    var currentFilterTexts = [];
    var currentFilterTextsOriginal = []; // Keep original text with "Currently Refined by" for selection announcements

    $('.filter-tags-container-desktop .sr-only.selected-assistive-text').each(function () {
        var text = $(this).data('announcement-text');
        if (text) {
            text = text.trim();
            // Store original text (with "Currently Refined by")
            currentFilterTextsOriginal.push(text.replace(/^selected\s*/i, '').trim());

            // Also store cleaned text (without "Currently Refined by") for comparison
            var cleanedText = text.replace(/^selected\s*/i, '').trim();
            cleanedText = cleanedText.replace(/^currently refined by\s*/i, '').trim();
            if (cleanedText) {
                currentFilterTexts.push(cleanedText);
            }
        }
    });

    var $announcer = $('#refinement-announcer');
    var announcementText = '';

    // Check if filters were removed (previous had more filters than current)
    if (previousSelectedFilters.length > currentFilterTexts.length) {
        // Find which filters were removed
        var removedFilters = previousSelectedFilters.filter(function (filter) {
            return currentFilterTexts.indexOf(filter) === -1;
        });

        // Check if ALL filters were removed at once (clear filters clicked)
        // This happens when: no filters remain AND more than 1 filter was removed
        if (currentFilterTexts.length === 0 && removedFilters.length > 1) {
            // Multiple filters were cleared at once
            announcementText = 'All filters removed';
        } else if (removedFilters.length > 0) {
            // Single filter was removed - use cleaned text without "Currently Refined by"
            var removedFilter = removedFilters[0]; // Take the first removed filter
            announcementText = 'Filter removed - ' + removedFilter;
        }
    } else if (currentFilterTextsOriginal.length > 0) {
        // Normal case: announce currently selected filters with "Currently Refined by"
        announcementText = currentFilterTextsOriginal.join(', ');
    }

    // Update the previous filters array for next comparison (use cleaned text)
    previousSelectedFilters = currentFilterTexts.slice(); // Make a copy

    // Clear announcer first, then set new text with a small delay for screen readers
    $announcer.text('');

    setTimeout(function () {
        $announcer.text(announcementText);
    }, 100);

    initFilterTags();
    updateStickyFilterTags();
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @param {boolean} noResults - No search results container presence flag
 * @return {undefined}
 */
function parseResults(response, noResults) {
    var $results = $(response);
    if (!noResults) {
        var specialHandlers = {
            '.refinements': handleRefinements,
            '.filter-tags-container': handleFilterTags
        };

        // Save old refinement panels before changing
        $refinementBar = $('#refinementBar').clone();
        $mobileRefinementBar = $('#mobileRefinementBar').clone();

        // Update DOM elements that do not require special handling
        [
            '.split-plp-header',
            '.grid-header',
            '.header-bar',
            '.header.page-title',
            '.product-grid',
            '.show-more',
            '.filter-bar',
            '.refinement-section',
            '.num-results span',
            '.mobile-sort',
            '.disclaimer-info-plpbanner',
            '.filter-header',
            '.filter-body',
            '.filter-footer',
            '.filter-button-wrapper',
            '.right-section-header'
        ].forEach(function (selector) {
            var update = true;
            if (selector === '.show-more') {
                update = $results.find(selector).length <= 1;
            }
            if (update) {
                updateDom($results, selector);
            }
        });

        Object.keys(specialHandlers).forEach(function (selector) {
            specialHandlers[selector]($results);
        });
    } else {
        updateDom($results, '.search-results');
    }
}

/**
 * Test if the tile image is loaded.
 *
 * @param {number} pos - Product tile position
 * @return {boolean} - tile image is loaded
 */
function isTileImageLoaded(pos) {
    var $container = $('.search-results');
    var el = $container.find('.product-tile').get(pos);
    var img = $(el).find('.plp-main-slide');

    if (img !== undefined) {
        var imgobj = img[0];

        if (!imgobj.complete) {
            return false;
        }
        if (typeof imgobj.naturalWidth !== 'undefined' && imgobj.naturalWidth === 0) {
            return false;
        }
    }

    return true;
}

/**
 * Scroll window to position of the last clicked product.
 *
 * @param {number} pos - Product tile position
 */
function scrollToPosition(pos) {
    if (pos > 0) {
        var $container = $('.search-results');
        var el = $container.find('.product-tile').get(pos);
        var offset = $(el).offset();
        if (offset != null) {
            $('html, body').animate({
                scrollTop: (offset.top + 100) - ($('header').height() + $('.sticky-refinement').height())
            }, 0);
            $.spinner().stop();
        }
    }

    $.spinner().stop();
}
/**
 * Trigger scrolling after tile image is loaded.
 *
 * @param {number} pos - Product tile position
 */
function scrollWhenLoaded(pos) {
    var $container = $('.search-results');
    var el = $container.find('.product-tile');
    if (!$('body').find('.veil').length) {
        $.spinner().start();
    }
    if (el.length > 0 && el.length > pos) {
        if (isTileImageLoaded(pos) === true) {
            scrollToPosition(pos);
        } else {
            setTimeout(function () {
                scrollWhenLoaded(pos);
            }, 500);
        }
    } else if ($('.show-more button').length > 0) {
        $('.show-more button').click();
        setTimeout(function () {
            scrollWhenLoaded(pos);
        }, 500);
    }
}

function handleScrollEvent() {
    let lis = [].slice.call(document.querySelectorAll('.product-grid .grid-list'));
    $('.product-grid .grid-list').removeClass('inView');
    if ('IntersectionObserver' in window) {
        let scrollPositionOberver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let li = $(entry.target);
                    /* eslint-disable */
                    if (entry['intersectionRatio'] >= 0.65) {
                        li.addClass('inView');
                    } else {
                        li.removeClass('inView');
                    }
                    /* eslint-enable */
                }
            });
        });
        lis.forEach(function (li) {
            scrollPositionOberver.observe(li);
        });
    }
    var $filterNavWrapper = $('.filter-nav-wrapper').outerHeight();
    var $stickyHeaderHeight = $('header').outerHeight();
    var $totalHeight = $filterNavWrapper + $stickyHeaderHeight;
    $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + ($totalHeight + 50) + 'px)');
}

function getSplitPLPGridParams() {
    var $gridFooters = $('.product-split-grid .grid-footer');
    var splitPLPGridParams = '';

    if ($gridFooters.length) {
        $gridFooters.each(function () {
            var $splitProductGrid = $(this).parents('.product-split-grid');
            var categoryId = $splitProductGrid.data('category-id');
            var splitProductGridProductTiles = $splitProductGrid.find('.product-tile').length;

            var splitProductGridProductTilesDesktop = splitProductGridProductTiles;
            var splitProductGridProductTilesTablet = splitProductGridProductTiles;
            var splitProductGridProductTilesMobile = splitProductGridProductTiles;
            $splitProductGrid.find('.hideGridTileDesktop').each(function () { if ($(this).find('.product-tile').length) splitProductGridProductTilesDesktop -= 1; });
            $splitProductGrid.find('.hideGridTileTablet').each(function () { if ($(this).find('.product-tile').length) splitProductGridProductTilesTablet -= 1; });
            $splitProductGrid.find('.hideGridTileMobile').each(function () { if ($(this).find('.product-tile').length) splitProductGridProductTilesMobile -= 1; });
            if ($(this).data('product-tiles-to-show')) splitProductGridProductTiles = $(this).data('product-tiles-to-show');
            if ($(this).data('product-tiles-to-show-desktop')) splitProductGridProductTilesDesktop = $(this).data('product-tiles-to-show-desktop');
            if ($(this).data('product-tiles-to-show-tablet')) splitProductGridProductTilesTablet = $(this).data('product-tiles-to-show-tablet');
            if ($(this).data('product-tiles-to-show-mobile')) splitProductGridProductTilesMobile = $(this).data('product-tiles-to-show-mobile');

            splitPLPGridParams += categoryId + ':' + splitProductGridProductTiles
                + '|' + splitProductGridProductTilesDesktop
                + '|' + splitProductGridProductTilesTablet
                + '|' + splitProductGridProductTilesMobile + ';';
        });
    }

    return splitPLPGridParams;
}

function getHashFromUrl(url) {
    var hashIndex = String(url).indexOf('#');
    return hashIndex > -1 ? String(url).substring(hashIndex) : '';
}

function getUrlWithoutHash(url) {
    var hashIndex = String(url).indexOf('#');
    return hashIndex > -1 ? String(url).substring(0, hashIndex) : String(url);
}

function getQueryStringWithoutHash(url) {
    var urlWithoutHash = getUrlWithoutHash(url);
    var queryIndex = urlWithoutHash.indexOf('?');

    return queryIndex > -1 ? urlWithoutHash.substring(queryIndex + 1) : '';
}

function appendParamsBeforeHash(url, params) {
    if (!params) {
        return url;
    }

    var hash = getHashFromUrl(url);
    var urlWithoutHash = getUrlWithoutHash(url);
    var cleanParams = String(params).replace(/^[?&]/, '');

    if (!cleanParams) {
        return urlWithoutHash + hash;
    }

    var lastChar = urlWithoutHash.charAt(urlWithoutHash.length - 1);
    var separator;

    if (urlWithoutHash.indexOf('?') > -1) {
        if (lastChar === '?' || lastChar === '&') {
            separator = '';
        } else {
            separator = '&';
        }
    } else {
        separator = '?';
    }

    return urlWithoutHash + separator + cleanParams + hash;
}

searchBase.applyFilter = function () {
    // Handle refinement value selection and reset click
    $('.container').on(
        'click change',
        '.refinements .refinement-input, .refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .filter-tag button, .filter-tags-reset button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $spinnerContainer = isMobile() && $('body').hasClass('filter-panel-is-open') ? $('#mobileRefinementBar') : $;

            $spinnerContainer.spinner().start();
            $(this).trigger('search:filter', e);

            var filterUrl = $(this).data('href');
            var urlParams = new URL(window.location.href).searchParams;
            var selectedSort = urlParams.get('srule');

            // Important: do not read query params after #.
            // Everything after # is a URL fragment, not query string.
            var selectedRefinements = getQueryStringWithoutHash(filterUrl);

            // Preserve anchor/hash at the very end of the browser URL.
            var historyHash = getHashFromUrl(filterUrl) || window.location.hash;
            var historyParams = selectedRefinements || '';

            if (selectedSort) {
                historyParams = historyParams
                    ? historyParams + '&srule=' + selectedSort
                    : 'srule=' + selectedSort;
            }

            var historyUrl = historyParams ? '?' + historyParams + historyHash : window.location.pathname + historyHash;

            replaceUrlAndSync(historyUrl);

            window.history.replaceState(
                null,
                null,
                historyParams ? '?' + historyParams + historyHash : window.location.pathname + historyHash
            );

            // show same number of tiles as before filters were applied
            var $splitProductGrids = $('.product-split-grid');
            var splitPLPGridParams = sessionStorage.getItem('splpGridParams');
            if ($splitProductGrids.length) {
                if (!splitPLPGridParams || !splitPLPGridParams.length) {
                    splitPLPGridParams = getSplitPLPGridParams();
                    sessionStorage.setItem('splpGridParams', splitPLPGridParams);
                }

                if (!selectedSort && (!selectedRefinements || selectedRefinements.indexOf('prefv') === -1)) {
                    var parentCategoryID = $splitProductGrids.data('root-category-id');
                    if (parentCategoryID) {
                        filterUrl = appendParamsBeforeHash(filterUrl, 'pcgid=' + parentCategoryID);
                    }

                    if (splitPLPGridParams && splitPLPGridParams.length) {
                        filterUrl = appendParamsBeforeHash(filterUrl, 'splp=' + splitPLPGridParams);
                        sessionStorage.setItem('splpGridParams', '');
                    }
                }
            } else {
                var plpTilesToShow = sessionStorage.getItem('plpTilesToShow');
                var plpTilesToShowDesktop = sessionStorage.getItem('plpTilesToShowDesktop');
                var plpTilesToShowTablet = sessionStorage.getItem('plpTilesToShowTablet');
                var plpTilesToShowMobile = sessionStorage.getItem('plpTilesToShowMobile');

                var $gridFooter = $('.grid-footer');
                if ((!plpTilesToShow || !plpTilesToShow.length) && $gridFooter && $gridFooter.data('product-tiles-to-show')) {
                    plpTilesToShow = $gridFooter.data('product-tiles-to-show');
                    sessionStorage.setItem('plpTilesToShow', plpTilesToShow);
                }
                if ((!plpTilesToShowDesktop || !plpTilesToShowDesktop.length) && $gridFooter && $gridFooter.data('product-tiles-to-show-desktop')) {
                    plpTilesToShowDesktop = $gridFooter.data('product-tiles-to-show-desktop');
                    sessionStorage.setItem('plpTilesToShowDesktop', plpTilesToShowDesktop);
                }
                if ((!plpTilesToShowTablet || !plpTilesToShowTablet.length) && $gridFooter && $gridFooter.data('product-tiles-to-show-tablet')) {
                    plpTilesToShowTablet = $gridFooter.data('product-tiles-to-show-tablet');
                    sessionStorage.setItem('plpTilesToShowTablet', plpTilesToShowTablet);
                }
                if ((!plpTilesToShowMobile || !plpTilesToShowMobile.length) && $gridFooter && $gridFooter.data('product-tiles-to-show-mobile')) {
                    plpTilesToShowMobile = $gridFooter.data('product-tiles-to-show-mobile');
                    sessionStorage.setItem('plpTilesToShowMobile', plpTilesToShowMobile);
                }


                if (!selectedSort && (!selectedRefinements || selectedRefinements.indexOf('prefv') === -1)) {
                    if (plpTilesToShow && plpTilesToShow.length) {
                        filterUrl = appendParamsBeforeHash(filterUrl, 'start=0&sz=' + plpTilesToShow);
                        sessionStorage.setItem('plpTilesToShow', '');
                    }
                    if (plpTilesToShowDesktop && plpTilesToShowDesktop.length) {
                        filterUrl = appendParamsBeforeHash(filterUrl, 'dsize=' + plpTilesToShowDesktop);
                        sessionStorage.setItem('plpTilesToShowDesktop', '');
                    }
                    if (plpTilesToShowTablet && plpTilesToShowTablet.length) {
                        filterUrl = appendParamsBeforeHash(filterUrl, 'tsize=' + plpTilesToShowTablet);
                        sessionStorage.setItem('plpTilesToShowTablet', '');
                    }
                    if (plpTilesToShowMobile && plpTilesToShowMobile.length) {
                        filterUrl = appendParamsBeforeHash(filterUrl, 'msize=' + plpTilesToShowMobile);
                        sessionStorage.setItem('plpTilesToShowMobile', '');
                    }

                    var categoryID = $('.category-id').val();
                    if (categoryID) {
                        filterUrl = appendParamsBeforeHash(filterUrl, 'pcgid=' + categoryID);
                    }

                    if (splitPLPGridParams && splitPLPGridParams.length) {
                        filterUrl = appendParamsBeforeHash(filterUrl, 'splp=' + splitPLPGridParams);
                        sessionStorage.setItem('splpGridParams', '');
                    }
                }
            }

            var hasResetclass = $(this).hasClass('reset');
            var selectedRefinmentParent = $(this).closest('li').data('id');

            $.ajax({
                url: filterUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: filterUrl,
                    selectedSort: selectedSort,
                    isPageDesigner: isPageDesigner,
                    pageId: pageDesignerId
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response, false);
                    handleSortPrefix();
                    if (selectedSort) {
                        updateSrule();
                    }
                    if (isDesktop()) {
                        getFilterPanelParam();
                    }
                    if ($('.refinement-panel-desktop').hasClass('show')) {
                        $('.top-refinement-bar-btn').removeClass('d-none');
                    }
                    if (hasResetclass) {
                        $('.refinement-url-value').val('');
                    } else {
                        $('.refinement-url-value').val(filterUrl);
                    }
                    $(document).trigger('custom:filter:buttons:updated');
                    hideSingleValueFromRefinement();

                    mobileFilterPanelControls();

                    $('body').trigger('quickview:loadButtons');

                    // Update sort
                    var sortLabel = $('.container .custom-select[name=sort-order]').find(':selected').data('value');
                    if (sortLabel !== undefined) {
                        $('.num-results .placeholder').html(sortLabel);
                    }

                    var numResultsText = $('.num-results span:visible').text();
                    // Clear first, then announce after refinement-announcer (which has 100ms delay)
                    $('#num-results-announcer').text('');
                    setTimeout(function () {
                        $('#num-results-announcer').text(numResultsText);
                    }, 400); // 400ms delay to ensure it announces after refinement-announcer

                    resetSort();
                    common.lazyLoad();
                    if (isDesktop()) {
                        var $focusTarget = $(`.refinements li[data-id="${selectedRefinmentParent}"]`).find('.refinement-input, button');
                        if ($focusTarget.length > 0) {
                            // Store the original aria-label
                            var originalAriaLabel = $focusTarget.attr('aria-label');

                            // Temporarily set empty aria-label to suppress announcement
                            $focusTarget.attr('aria-label', '');

                            // Wait for live regions to announce (800ms), then focus
                            setTimeout(function () {
                                $focusTarget.focus();

                                // Restore original aria-label after focus
                                setTimeout(function () {
                                    if (originalAriaLabel) {
                                        $focusTarget.attr('aria-label', originalAriaLabel);
                                    } else {
                                        $focusTarget.removeAttr('aria-label');
                                    }
                                }, 100);
                            }, 800);
                        }
                    } else {
                        refinementSelected = true;
                    }
                },
                complete: function () {
                    scrollOnApplyRefinement();
                    $spinnerContainer.spinner().stop();
                }
            });
        });
};

const updatePLPGridUrl = function () {
    var productTile = $('.product-grid .product-tile').length;
    var productTileDesktop = productTile;
    var productTileTablet = productTile;
    var productTileMobile = productTile;
    var $gridFooters = $('.grid-footer');

    var splitPLPGridParams = '';
    if ($gridFooters.length > 1) {
        splitPLPGridParams = getSplitPLPGridParams();
    } else if ($gridFooters.length) {
        $('.hideGridTileDesktop').each(function () { if ($(this).find('.product-tile').length) productTileDesktop -= 1; });
        $('.hideGridTileTablet').each(function () { if ($(this).find('.product-tile').length) productTileTablet -= 1; });
        $('.hideGridTileMobile').each(function () { if ($(this).find('.product-tile').length) productTileMobile -= 1; });
        if ($gridFooters.data('product-tiles-to-show')) productTile = $gridFooters.data('product-tiles-to-show');
        if ($gridFooters.data('product-tiles-to-show-desktop')) productTileDesktop = $gridFooters.data('product-tiles-to-show-desktop');
        if ($gridFooters.data('product-tiles-to-show-tablet')) productTileTablet = $gridFooters.data('product-tiles-to-show-tablet');
        if ($gridFooters.data('product-tiles-to-show-mobile')) productTileMobile = $gridFooters.data('product-tiles-to-show-mobile');
    }

    const url = new URL(window.location.href);
    if (splitPLPGridParams && splitPLPGridParams.length) {
        url.searchParams.set('splp', splitPLPGridParams);

        var $splitProductGrids = $('.product-split-grid');
        if ($splitProductGrids.length) {
            var parentCategoryID = $splitProductGrids.data('root-category-id');
            if (parentCategoryID) {
                url.searchParams.set('pcgid', parentCategoryID);
            }
        }
    } else {
        url.searchParams.set('start', '0');
        url.searchParams.set('sz', productTile);
        url.searchParams.set('dsize', productTileDesktop);
        url.searchParams.set('tsize', productTileTablet);
        url.searchParams.set('msize', productTileMobile);
    }
    url.searchParams.set('isBack', true);
    replaceUrlAndSync(url);
};

searchBase.handleBackbutton = function () {
    $(document).on('click', '.product-tile .pdp-link a, .product-tile .carousel-item.active a, .product-tile .more-color a, .experience-region .pd-contentTile a, .product-quickview a.pdp-link',
        function () {
            var scrollPosition = $(document).scrollTop();
            sessionStorage.setItem('scrollPosition', scrollPosition.toString());
            sessionStorage.setItem('productIdFromSession', $(this).closest('.product').attr('data-pid'));
            if ($('.refinement-url-value').val() !== '') {
                var pos = $(this).parents('.product-tile').index('.product-tile');
                var refinementUrl = $('.refinement-url-value').val();
                var hashParam = refinementUrl.split('#');
                if (hashParam.length > 1 && hashParam[1].indexOf('pos') > -1) {
                    refinementUrl = hashParam[0];
                }
                refinementUrl += '#pos=' + pos;
            }
            updatePLPGridUrl();
        });
    if (window.history.state && window.history.state !== '' && $.isNumeric(window.history.state)) {
        common.lazyLoad();
        if (isNaN(window.history.state)) {
            window.history.state = 0;
        }
        scrollWhenLoaded(window.history.state);
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('isBack', true);
    replaceUrlAndSync(url);
};

function updatePLPBadges(tile, badges) {
    var badgePrimaryContainer = tile.find('.product-badge-container');
    var badgeSecondaryContainer = tile.find('.plp-label--secondary');
    var badgeTertiary = tile.find('.plp-label--tertiary');

    if (badges.plpBadgePrimaryHtml && badgePrimaryContainer.length > 0) {
        badgePrimaryContainer.html(badges.plpBadgePrimaryHtml);
    }
    if (badges.plpBadgeSecondaryHtml && badgeSecondaryContainer.length > 0) {
        badgeSecondaryContainer.html(badges.plpBadgeSecondaryHtml);
    }
    if (badges.plpBadgeTertiaryHtml && badgeTertiary.length > 0) {
        badgeTertiary.html(badges.plpBadgeTertiaryHtml);
    }
}

/**
 * toggles visibility between image and video for the productTileMixedMedia template
 * for when user selects a swatch that does not correlate to the the custom video target product
 * @param {string} tile PLP grid productTile markup provided by the searchBase.selectVariation selector
 * @param {string} selectedSwatchColorID color code for the returned product data from the swatch AJAX call
 */
function handleCustomProductTileSwatchInteraction(tile, selectedSwatchColorID) {
    let customTileColorID = tile.attr('product-color');

    if (customTileColorID === selectedSwatchColorID) {
        tile.find('.custom-product-tile-mixed-media').removeClass('d-none');
        tile.find('.custom-product-tile-default-image').addClass('d-none');
    } else {
        tile.find('.custom-product-tile-mixed-media').addClass('d-none');
        tile.find('.custom-product-tile-default-image').removeClass('d-none');
    }
}
/**
 * change tile image when user change the color swatches
 */
searchBase.selectVariation = function () {
    $(document).on('click', '.product-tile .swatch-item.swatch-circle.color-value', function () {
        var swatchcircle = $(this).find('.swatch.swatch-circle');
        var $clickedRadio = $(this).find('.radio-color-btn');
        var url = swatchcircle.data('variation-url');
        var PDPUrl = url.replace('Variation', 'Show');
        var quickViewUrl = url.replace('Variation', 'ShowQuickView');
        var tile = swatchcircle.closest('.product-tile');
        var prevSelectedSwatch = tile.find('.selected');
        tile.find('.selected').removeClass('selected');
        swatchcircle.addClass('selected');
        // Update radio checked state immediately (both property and attribute)
        tile.find('.radio-color-btn').each(function () {
            this.checked = false;
            this.removeAttribute('checked');
        });
        if ($clickedRadio.length) {
            $clickedRadio[0].checked = true;
            $clickedRadio[0].setAttribute('checked', '');
        }
        var cgid = $('.category-id').val();

        console.log('selecting variation'); // eslint-disable-line no-console

        if (cgid) {
            url = utils.appendParamToURL(url, 'cgid', cgid);
        }

        $.ajax({
            url: url,
            method: 'GET',
            success: function (response) {
                var desktopDefault = response.imagesDefaultHover.desktopDefault;
                var mobileDefault = response.imagesDefaultHover.mobileDefault;
                var desktopHover = response.imagesDefaultHover.desktopHover;
                var mobileHover = response.imagesDefaultHover.mobileHover;
                var selectedColorText = null;

                try {
                    selectedColorText = response.product.variationAttributes
                        .filter(item => item.displayName.toLowerCase() === 'color')[0].values
                        .filter(colorObj => colorObj.selected === true)[0].displayValue;
                } catch (err) {
                    console.error(err); // eslint-disable-line no-console
                }
                if (response.product.price.html) {
                    tile.find('.price').replaceWith(response.product.price.html);
                }
                if (response.product.price.type === 'salePriceRange') {
                    tile.find('.price').addClass('sale-price-group');
                } else {
                    tile.find('.price').removeClass('sale-price-group');
                }
                common.lazyLoad();

                var isVG = response.isVG;
                var PDPUrlVG = PDPUrl;
                if (isVG && isVG === 'true' && response.urls.product) {
                    PDPUrlVG = response.urls.product;
                }

                tile.find('.selected').removeClass('selected');
                swatchcircle.addClass('selected');
                tile.find('.js-image-wrapper').attr('href', PDPUrlVG);


                tile.find('.js-image-wrapper').find('picture').each(function (index, el) {
                    let mobileImage = index === 0 ? mobileDefault : mobileHover;
                    let desktopImage = index === 0 ? desktopDefault : desktopHover;

                    $(el).find('source[media="(min-width:992px)"]').attr('srcset', desktopImage.url);
                    $(el).find('source[media="(max-width:991px)"]').attr('srcset', mobileImage.url);
                    $(el).find('img')
                        .attr('src', desktopImage.url)
                        .attr('alt', desktopImage.alt)
                        .attr('title', desktopImage.title);
                });

                if (selectedColorText) {
                    tile.find('.tile-color-name').text(selectedColorText);
                }
                tile.find('.quickview').attr('href', quickViewUrl);
                if (response.urls) {
                    tile.find('.pdp-link a').attr('href', response.urls.product);
                } else if (PDPUrl) {
                    tile.find('.pdp-link a').attr('href', PDPUrl);
                }

                updatePLPBadges(tile, response.badges);
                // page designer custom product tile component swatch updates
                if (tile && tile.attr('custom-product-tile')) {
                    let selectedSwatchColorID = response.product.variationAttributes
                        .filter(item => item.displayName.toLowerCase() === 'color')[0].values
                        .filter(colorObj => colorObj.selected === true)[0].id;

                    handleCustomProductTileSwatchInteraction(tile, selectedSwatchColorID);
                }
            },
            error: function () {
                tile.find('.selected').removeClass('selected');
                if (prevSelectedSwatch.length > 0) {
                    prevSelectedSwatch.addClass('selected');
                }
            }
        });
    });
    // Keyboard navigation for color swatches
    $(document).on('keydown', '.radio-color-btn', function (evt) {
        var $currentRadio = $(this);
        var $radioGroup = $currentRadio.closest('fieldset');
        var $allRadios = $radioGroup.find('.radio-color-btn');
        var currentIndex = $allRadios.index($currentRadio);
        var $targetRadio = null;

        switch (evt.which) {
            case 37: // Left arrow
            case 38: // Up arrow
                evt.preventDefault();
                $targetRadio = currentIndex > 0 ? $allRadios.eq(currentIndex - 1) : $allRadios.last();
                break;
            case 39: // Right arrow
            case 40: // Down arrow
                evt.preventDefault();
                $targetRadio = currentIndex < $allRadios.length - 1 ? $allRadios.eq(currentIndex + 1) : $allRadios.first();
                break;
            case 32: // Space
            case 13: // Enter
                evt.preventDefault();
                // Trigger click on the swatch-item parent
                var $swatchItem = $currentRadio.closest('.color-value.swatch-circle.swatch-item');
                if ($swatchItem.length) {
                    $swatchItem.trigger('click');
                }
                return;
            default:
                // Let other keys pass through
                break;
        }

        if ($targetRadio) {
            $targetRadio.focus();
            // Trigger selection on the parent swatch-item (this will update checked state)
            var $targetSwatchItem = $targetRadio.closest('.color-value.swatch-circle.swatch-item');
            if ($targetSwatchItem.length) {
                $targetSwatchItem.trigger('click');
            }
        }
    });

    // Legacy support for direct label keyboard interaction
    $(document).on('keydown', 'span .swatch.swatch-circle', function (evt) {
        if (evt.which === 13 || evt.which === 32) {
            evt.preventDefault();
            $(this).trigger('click');
        }
    });


    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
        $('.product-tile .swatches .swatch-item').addClass('safari-mac');
    }

    $(document).on('ajaxComplete', function () {
        if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
            $('.product-tile .swatches .swatch-item').addClass('safari-mac');
        }
    });
};

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Update applied filter after sort selection
 *
 * @return {undefined}
 */
function updateAppliedFilter() {
    var $selectedFilterList = $('.filter-bar ul.d-md-none');
    var selectedFilterCount = parseInt($('.filter-bar ul.d-md-none').children().eq(2).data('value'), 10) + 1;
    if ($selectedFilterList.children().length >= 3) {
        $selectedFilterList.children().last().html('+' + selectedFilterCount.toString() + 'More');
        $selectedFilterList.children().eq(1).remove();
    }
}

/**
 * Retrieves the value associated with the scroll of the browser
 * @param {jquery} el - DOM container for the relevant element
 * @return {string} - value found in the quantity input
 */
function isInViewport(el) {
    var elementTop = $(el).offset().top;
    var elementBottom = elementTop + $(el).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
}

/**
 * updates page designer content tile image sizes to match product tile height
 */
function handleContentTileResize() {
    var $contentTileImageWrappers = $('.pd-contentTile .image-wrapper');
    if ($contentTileImageWrappers) {
        var initialProductTileImageHeight = $('.product-tile-image-wrapper').innerHeight();
        if (initialProductTileImageHeight) {
            $contentTileImageWrappers.innerHeight(initialProductTileImageHeight);
        }
    }
}
var debounceHandleContentTileResize = debounce(handleContentTileResize, 200);

searchBase.showMore = function () {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        if (showMoreResult === true) {
            showMoreResult = false;
            e.stopPropagation();
            var showMoreUrl = $(this).data('url');
            showMoreUrl += '&showAll=' + $('.show-all button').hasClass('active');
            e.preventDefault();

            var parentCategoryID = '';
            var $splitProductGrids = $('.product-split-grid');
            if ($splitProductGrids.length) {
                parentCategoryID = $splitProductGrids.data('root-category-id') || '';
            }

            var $splitPLPGrids = $('.product-split-grid');
            var splitPLPDefaultSectionTileCounts = '';
            if ($splitPLPGrids.length) {
                $splitPLPGrids.each(function () {
                    var sectionCategoryId = $(this).data('category-id');
                    var defaultSectionTileCount = $(this).data('default-section-tile-count');
                    if (sectionCategoryId && defaultSectionTileCount) {
                        splitPLPDefaultSectionTileCounts += sectionCategoryId + ':' + defaultSectionTileCount + ';';
                    }
                });
            }

            var $this = $(this);
            $this.trigger('search:showMore', e);
            $.spinner().start();
            if ($(this).data('url') !== '') {
                $.ajax({
                    url: showMoreUrl,
                    data: { selectedUrl: showMoreUrl, isPageDesigner: isPageDesigner, pageId: pageDesignerId, pcgid: parentCategoryID, sectionTileCounts: splitPLPDefaultSectionTileCounts },
                    method: 'GET',
                    success: function (response) {
                        if (!('scrollPosition' in sessionStorage && performance.navigation.type === 2 && loadFlag)) {
                            var headerHeight = $('header').outerHeight();
                            var stickyRefinment = $('.sticky-refinement').outerHeight();
                            var productPosition = $('.product-grid').find('.grid-list:last');
                            if (isDesktop()) {
                                productPosition = $('.product-grid').find('.grid-list:not(.hideGridTileDesktop):last');
                            } else if (window.innerWidth >= 768) {
                                productPosition = $('.product-grid').find('.grid-list:not(.hideGridTileTablet):last');
                            } else {
                                productPosition = $('.product-grid').find('.grid-list:not(.hideGridTileMobile):last');
                            }
                            var productOffset = productPosition.length ? productPosition.offset().top : '';
                            if (isInViewport('#footercontent .footer-container') || isInViewport('#footercontent .footer-container:last')) {
                                $('html, body').animate({
                                    scrollTop: (productOffset - headerHeight - stickyRefinment) + 'px'
                                }, 0);
                                // window.isAutoScrolledFlag = false;
                            }
                        }

                        var $splitProductGrid = $this.parents('.product-split-grid');

                        // unhide hidden tiles
                        var $tilesToUnhide = $('.hideGridTileDesktop, .hideGridTileTablet, .hideGridTileMobile').filter(function () {
                            if ($splitProductGrid.length) {
                                return ($splitProductGrid.has(this).length && !$(this).parents('#pd-gridRegionsToRender').length);
                            }
                            return !$(this).parents('#pd-gridRegionsToRender').length;
                        });
                        $tilesToUnhide.removeClass('hideGridTileDesktop').removeClass('hideGridTileTablet').removeClass('hideGridTileMobile');

                        var $gridFooter = $splitProductGrid.length ? $splitProductGrid.find('.grid-footer') : $('.grid-footer');
                        var updatedResponse = injectRenderedGridRegions(response);
                        if (updatedResponse) {
                            $gridFooter.replaceWith(updatedResponse);
                        } else {
                            $gridFooter.replaceWith(response);
                        }
                        updateSortOptions(response);
                        handleScrollEvent();

                        // commented out in context of PMG-1675 because it causes unexpected scrolling on load more
                        // if ('scrollPosition' in sessionStorage && performance.navigation.type === 2) {
                        //     $('html, body').animate({
                        //         scrollTop: sessionStorage.getItem('scrollPosition')
                        //     }, 0);
                        //     loadFlag = false;
                        // }

                        if ($splitProductGrid.length) {
                            var splitProductGridProductTile = $splitProductGrid.find('.product-tile').length;
                            var splitProductGridProductTilesHiddenDesktop = 0;
                            var splitProductGridProductTilesHiddenTablet = 0;
                            var splitProductGridProductTilesHiddenMobile = 0;
                            $splitProductGrid.find('.hideGridTileDesktop').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    splitProductGridProductTilesHiddenDesktop += 1;
                                }
                            });
                            $splitProductGrid.find('.hideGridTileTablet').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    splitProductGridProductTilesHiddenTablet += 1;
                                }
                            });
                            $splitProductGrid.find('.hideGridTileMobile').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    splitProductGridProductTilesHiddenMobile += 1;
                                }
                            });
                            $splitProductGrid.find('.custom-product-tile').each(function () {
                                if ($(this).hasClass('mobile-size-0')) {
                                    splitProductGridProductTilesHiddenMobile += 1;
                                    splitProductGridProductTilesHiddenTablet += 1;
                                }
                                if ($(this).hasClass('desktop-size-0')) {
                                    splitProductGridProductTilesHiddenDesktop += 1;
                                }
                            });
                            $splitProductGrid.find('.p-count .page-size').text(splitProductGridProductTile);
                            $splitProductGrid.find('.p-count .page-size-desktop').text(splitProductGridProductTile - splitProductGridProductTilesHiddenDesktop);
                            $splitProductGrid.find('.p-count .page-size-tablet').text(splitProductGridProductTile - splitProductGridProductTilesHiddenTablet);
                            $splitProductGrid.find('.p-count .page-size-mobile').text(splitProductGridProductTile - splitProductGridProductTilesHiddenMobile);
                        } else {
                            var productTile = $('.product-grid .product-tile:not(#pd-gridRegionsToRender .product-tile)').length;
                            var productTilesHiddenDesktop = 0;
                            var productTilesHiddenTablet = 0;
                            var productTilesHiddenMobile = 0;
                            $('.hideGridTileDesktop').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    productTilesHiddenDesktop += 1;
                                }
                            });
                            $('.hideGridTileTablet').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    productTilesHiddenTablet += 1;
                                }
                            });
                            $('.hideGridTileMobile').each(function () {
                                if ($(this).find('.product-tile').length) {
                                    productTilesHiddenMobile += 1;
                                }
                            });
                            $('.custom-product-tile:not(#pd-gridRegionsToRender .custom-product-tile)').each(function () {
                                if ($(this).hasClass('mobile-size-0')) {
                                    productTilesHiddenMobile += 1;
                                    productTilesHiddenTablet += 1;
                                }
                                if ($(this).hasClass('desktop-size-0')) {
                                    productTilesHiddenDesktop += 1;
                                }
                            });
                            $('.p-count .page-size').text(productTile);
                            $('.p-count .page-size-desktop').text(productTile - productTilesHiddenDesktop);
                            $('.p-count .page-size-tablet').text(productTile - productTilesHiddenTablet);
                            $('.p-count .page-size-mobile').text(productTile - productTilesHiddenMobile);
                        }
                        $('body').trigger('quickview:loadButtons');
                        $.spinner().stop();
                        showMoreResult = true;
                    },
                    error: function () {
                        $.spinner().stop();
                        showMoreResult = true;
                    }
                });
            } else {
                if (!('scrollPosition' in sessionStorage && performance.navigation.type === 2 && loadFlag)) {
                    var headerHeight = $('header').outerHeight();
                    var stickyRefinment = $('.sticky-refinement').outerHeight();
                    var productPosition = $('.product-grid').find('.grid-list:last');
                    if (isDesktop()) {
                        productPosition = $('.product-grid').find('.grid-list:not(.hideGridTileDesktop):last');
                    } else if (window.innerWidth >= 768) {
                        productPosition = $('.product-grid').find('.grid-list:not(.hideGridTileTablet):last');
                    } else {
                        productPosition = $('.product-grid').find('.grid-list:not(.hideGridTileMobile):last');
                    }

                    var productOffset = productPosition.length ? productPosition.offset().top : '';
                    if (isInViewport('#footercontent .footer-container') || isInViewport('#footercontent .footer-container:last')) {
                        $('html, body').animate({
                            scrollTop: (productOffset - headerHeight - stickyRefinment) + 'px'
                        }, 0);
                        // window.isAutoScrolledFlag = false;
                    }
                }

                var $splitProductGrid = $this.parents('.product-split-grid');

                // unhide hidden tiles
                var $tilesToUnhide = $('.hideGridTileDesktop, .hideGridTileTablet, .hideGridTileMobile').filter(function () {
                    if ($splitProductGrid.length) {
                        return ($splitProductGrid.has(this).length && !$(this).parents('#pd-gridRegionsToRender').length);
                    }
                    return !$(this).parents('#pd-gridRegionsToRender').length;
                });

                $tilesToUnhide.removeClass('hideGridTileDesktop').removeClass('hideGridTileTablet').removeClass('hideGridTileMobile');

                var $gridFooter = $splitProductGrid.length ? $splitProductGrid.find('.grid-footer') : $('.grid-footer');
                $gridFooter.find('.grid-footer-count-btns').remove();

                handleScrollEvent();

                // commented out in context of PMG-1675 because it causes unexpected scrolling on load more
                // if ('scrollPosition' in sessionStorage && performance.navigation.type === 2) {
                //     $('html, body').animate({
                //         scrollTop: sessionStorage.getItem('scrollPosition')
                //     }, 0);
                //     loadFlag = false;
                // }

                if ($splitProductGrid.length) {
                    var splitProductGridProductTile = $splitProductGrid.find('.product-tile').length;
                    var splitProductGridProductTilesHiddenDesktop = 0;
                    var splitProductGridProductTilesHiddenTablet = 0;
                    var splitProductGridProductTilesHiddenMobile = 0;
                    $splitProductGrid.find('.hideGridTileDesktop').each(function () {
                        if ($(this).find('.product-tile').length) {
                            splitProductGridProductTilesHiddenDesktop += 1;
                        }
                    });
                    $splitProductGrid.find('.hideGridTileTablet').each(function () {
                        if ($(this).find('.product-tile').length) {
                            splitProductGridProductTilesHiddenTablet += 1;
                        }
                    });
                    $splitProductGrid.find('.hideGridTileMobile').each(function () {
                        if ($(this).find('.product-tile').length) {
                            splitProductGridProductTilesHiddenMobile += 1;
                        }
                    });
                    $splitProductGrid.find('.custom-product-tile').each(function () {
                        if ($(this).hasClass('mobile-size-0')) {
                            splitProductGridProductTilesHiddenMobile += 1;
                            splitProductGridProductTilesHiddenTablet += 1;
                        }
                        if ($(this).hasClass('desktop-size-0')) {
                            splitProductGridProductTilesHiddenDesktop += 1;
                        }
                    });
                    $splitProductGrid.find('.p-count .page-size').text(splitProductGridProductTile);
                    $splitProductGrid.find('.p-count .page-size-desktop').text(splitProductGridProductTile - splitProductGridProductTilesHiddenDesktop);
                    $splitProductGrid.find('.p-count .page-size-tablet').text(splitProductGridProductTile - splitProductGridProductTilesHiddenTablet);
                    $splitProductGrid.find('.p-count .page-size-mobile').text(splitProductGridProductTile - splitProductGridProductTilesHiddenMobile);
                    $gridFooter.data('product-tiles-to-show', splitProductGridProductTile);
                    $gridFooter.data('product-tiles-to-show-desktop', splitProductGridProductTile - splitProductGridProductTilesHiddenDesktop);
                    $gridFooter.data('product-tiles-to-show-tablet', splitProductGridProductTile - splitProductGridProductTilesHiddenTablet);
                    $gridFooter.data('product-tiles-to-show-mobile', splitProductGridProductTile - splitProductGridProductTilesHiddenMobile);
                } else {
                    var productTile = $('.product-grid .product-tile:not(#pd-gridRegionsToRender .product-tile)').length;
                    var productTilesHiddenDesktop = 0;
                    var productTilesHiddenTablet = 0;
                    var productTilesHiddenMobile = 0;
                    $('.hideGridTileDesktop').each(function () {
                        if ($(this).find('.product-tile').length) {
                            productTilesHiddenDesktop += 1;
                        }
                    });
                    $('.hideGridTileTablet').each(function () {
                        if ($(this).find('.product-tile').length) {
                            productTilesHiddenTablet += 1;
                        }
                    });
                    $('.hideGridTileMobile').each(function () {
                        if ($(this).find('.product-tile').length) {
                            productTilesHiddenMobile += 1;
                        }
                    });
                    $('.custom-product-tile:not(#pd-gridRegionsToRender .custom-product-tile)').each(function () {
                        if ($(this).hasClass('mobile-size-0')) {
                            productTilesHiddenMobile += 1;
                            productTilesHiddenTablet += 1;
                        }
                        if ($(this).hasClass('desktop-size-0')) {
                            productTilesHiddenDesktop += 1;
                        }
                    });
                    $('.p-count .page-size').text(productTile);
                    $('.p-count .page-size-desktop').text(productTile - productTilesHiddenDesktop);
                    $('.p-count .page-size-tablet').text(productTile - productTilesHiddenTablet);
                    $('.p-count .page-size-mobile').text(productTile - productTilesHiddenMobile);
                    $gridFooter.data('product-tiles-to-show', productTile);
                    $gridFooter.data('product-tiles-to-show-desktop', productTile - productTilesHiddenDesktop);
                    $gridFooter.data('product-tiles-to-show-tablet', productTile - productTilesHiddenTablet);
                    $gridFooter.data('product-tiles-to-show-mobile', productTile - productTilesHiddenMobile);
                }
                $.spinner().stop();
                showMoreResult = true;
            }
        }
    });
};

searchBase.endlessScroll = function () {
    $('.container').on('click', '.show-all button', function () {
        $.spinner().start();
        $(this).addClass('active');
        $(this).closest('.grid-footer').find('.show-all button, .show-more button').addClass('d-none');
        $(this).closest('.grid-footer').find('.show-more button').click();

        $(window).scroll(function () {
            var $splitPLPActiveShowAllButtons = $('.product-split-grid .show-all button.active');
            var firstSplitPLPActiveShowAllButton = $splitPLPActiveShowAllButtons.length ? $splitPLPActiveShowAllButtons[0] : null;
            var product = $('.container').find('.row.product-grid').find('.col-6').get(0);
            var productHeight = $(product).height();
            if ($(this).scrollTop() + 1 >= $('body').height() - $(window).height() - $('#footercontent').height() - productHeight) {
                if ($('.show-more button').length > 0) {
                    $('.show-more button').click();
                }
            } else if (firstSplitPLPActiveShowAllButton && ($(this).scrollTop() + 1 >= $(firstSplitPLPActiveShowAllButton).offset().top - $(window).height() - productHeight)) {
                $(firstSplitPLPActiveShowAllButton).click();
            } else if ('scrollPosition' in sessionStorage && performance.navigation.type === 2) {
                if ($(window).scrollTop() >= sessionStorage.getItem('scrollPosition')) {
                    sessionStorage.removeItem('scrollPosition');

                    loadFlag = true;
                }
            }
            if ($(this).scrollTop() + 1 >= $('body').height() - $(window).height() - $('#footercontent').height()) {
                if ($('.show-more button').length > 0) {
                    $.spinner().start();
                }
            }
            setCustomSelectWidth();
            window.isAutoScrolledFlag = true;
        });
    });
};

searchBase.slider = function () {
    $('.primary-images').mouseenter(function () {
        if (breakpoints.isDesktopView()) {
            $('.carousel-control-prev', this).removeClass('d-none');
            $('.carousel-control-next', this).removeClass('d-none');
        }
    });
    $('.primary-images').mouseleave(function () {
        if (breakpoints.isDesktopView()) {
            $('.carousel-control-prev', this).addClass('d-none');
            $('.carousel-control-next', this).addClass('d-none');
        }
    });
};

searchBase.filter = function () {
    $('.container').on('click', '.hidden-filter-tags-count-container', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isFilterPanelClosed = $('.refinements-sidebar').hasClass('animate');
        if (isFilterPanelClosed) {
            var $filterResultsButton = $('button.filter-results');
            if ($filterResultsButton && $filterResultsButton.length) {
                $filterResultsButton[0].click();
            }
        }
    });

    // Display refinements bar when Menu icon clicked
    $('.container').on('click', 'button.filter-results, .mobile-sort-btn', function (e) {
        var $button = $(this);
        var isOpeningDesktop = false;

        if (isDesktop()) {
            e.preventDefault();
            e.stopPropagation();
            // Check if panel is opening (has animate class before toggle)
            isOpeningDesktop = $('.refinements-sidebar').hasClass('animate');

            if (performance.navigation.type === 2 && backButtonFlag) {
                backButtonFlag = false;
            } else {
                sessionStorage.setItem('productIdFromSession', $('.grid-list.inView:first').find('.product').attr('data-pid'));
            }
            var isExpanded = $(this).attr('aria-expanded') === 'true';
            // var productId = sessionStorage.getItem('productIdFromSession') || $('.grid-list.inView:first').find('.product').attr('data-pid'); // PMG-863
            $(this).attr('aria-expanded', !isExpanded);
            $('.refinements-sidebar').toggleClass('animate col-md-3 col-md-0');
            $button.toggleClass('arrow-down');
            $('.view-filter').toggleClass('col-md-9 col-12');
            getFilterPanelParam();
            var currele = $button;
            var togglefilters = currele.find('.filter-text').find('.show-filters');
            togglefilters.toggleClass('d-none');
            togglefilters.siblings().toggleClass('d-none');

            // PMG-863 prevents scrolling to top of product tile on filter expand / collapse
            // $('.product-grid').addClass('active');
            // setTimeout(function () {
            //     var headerHeight = $('header').outerHeight();
            //     var stickyRefinment = $('.filter-nav-wrapper').outerHeight();
            //     var productPosition = $('.grid-list').find(`.product[data-pid="${productId}"]`).closest('.grid-list');
            //     if (productPosition.length > 0) {
            //         var productOffset = productPosition.offset().top;
            //         $([document.documentElement, document.body]).animate({
            //             scrollTop: (productOffset - (headerHeight + stickyRefinment)) + 'px'
            //         }, 0);
            //     }
            //     $('.product-grid').removeClass('active');
            // }, 275);

            var $filterNavWrapper = $('.filter-nav-wrapper').outerHeight();
            var $stickyHeaderHeight = $('header').outerHeight();
            var $totalHeight = $filterNavWrapper + $stickyHeaderHeight;
            $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + ($totalHeight + 50) + 'px)');
        }
        $('.refinement-bar-btn').siblings('.scroll-down-msg').hide();
        setTimeout(function () {
            if ($('.refinement-panel .refinements').height() >= 300) {
                $('.refinement-bar-btn').siblings('.scroll-down-msg').show();
            }

            if ($('#mobileRefinementBar .refinement-panel .refinements').height() >= 300) {
                $('#mobileRefinementBar .refinement-bar-btn').siblings('.scroll-down-msg').show();
            }

            if ($('.collapse-left').hasClass('show')) {
                // Move focus to first focusable element in mobile refinement panel for accessibility
                var $mobileRefinementPanel = $('#mobileRefinementBar');
                var $firstFocusable = $mobileRefinementPanel.find('.refinement-panel').find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
                if ($firstFocusable.length) {
                    $firstFocusable.focus();
                } else {
                    // Fallback to close button if no other focusable elements found
                    $mobileRefinementPanel.find('.close').trigger('focus');
                }
            }
        }, 500);

        if (isMobile() && $('.btn.filter-results:visible').hasClass('collapsed')) {
            $('html').addClass('js-no-scroll');
        } else {
            $('html').removeClass('js-no-scroll');
        }
        $('.collapse-left .container').scrollTop(0);
        $('.refinement-bar').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);

        // IMPORTANT: Always keep screen reader announcers accessible
        $('#refinement-announcer, #num-results-announcer').removeAttr('aria-hidden');
        setTimeout(function () {
            hideSingleValueFromRefinement();
        }, 10);

        // Move focus to newly revealed content for accessibility (Desktop)
        if (isDesktop() && isOpeningDesktop) {
            // Desktop: Filter panel is opening - move focus to first focusable element in refinement bar
            setTimeout(function () {
                var $refinementBarElement = $('#refinementBar');
                var $firstFocusable = $refinementBarElement.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first();
                if ($firstFocusable.length) {
                    $firstFocusable.focus();
                } else if ($refinementBarElement.length) {
                    // Fallback: focus on container if no focusable elements found
                    $refinementBarElement.focus();
                }
            }, 300);
        } else if (isDesktop() && !isOpeningDesktop) {
            // Desktop: Filter panel is closing - return focus to button
            setTimeout(function () {
                $button.focus();
            }, 300);
        } else if (!isDesktop()) {
            // Mobile: Focus handled separately in the mobile-specific code above
            $button.focus();
        }

        $('.refinement-panel .container').scrollTop(0);
        setTimeout(function () {
            if (!$('.btn.filter-results:visible').hasClass('collapsed')) {
                $('.top-refinement-bar-btn').removeClass('d-none');
            } else {
                $('.top-refinement-bar-btn').addClass('d-none');
            }
        }, 10);
        debounceUpdateStickyFilterTags();
    });

    $(window).on('scroll', function () {
        handleScrollEvent();
        var $filterNavWrapper = $('.filter-nav-wrapper');
        var headerHeight = $('header').outerHeight();
        if (window.pageYOffset > headerHeight) {
            $filterNavWrapper.find('.srp-no-plp').removeClass('d-none');
        } else {
            $filterNavWrapper.find('.srp-no-plp').addClass('d-none');
        }

        $('.sticky-refinement').toggleClass('is-sticky', isFilterTagBarSticky());
        updateStickyFilterTags();
    });

    $(window).on('resize', debounce(function () {
        var newWindowSize = $(window).width();
        if (newWindowSize < 992 && !$('.filter-tags-list').hasClass('slick-initialized')) {
            initFilterTags();
        }

        updateStickyFilterTags();
    }, 200));

    var $plpBreadcrumbs = $('.plp-breadcrumbs').outerHeight();
    var $stickyHeaderHeight = $('header').outerHeight();
    var $plpHeader = $('.plp-header-text').outerHeight();
    var $totalHeight = $plpBreadcrumbs + $plpHeader + $stickyHeaderHeight;
    $('.refinements-sidebar .refinement-bar-desktop').css('height', 'calc(100vh - ' + ($totalHeight + 100) + 'px)');
};

searchBase.closeRefinements = function () {
    // Refinements close button
    $('.container').on('click', '.refinement-bar button.close, .cancel-filter', function () {
        $('.modal-background').hide();
        $('.btn.filter-results:visible').click();
        $('.refinement-bar').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);

        // IMPORTANT: Ensure screen reader announcers are always accessible
        $('#refinement-announcer, #num-results-announcer').removeAttr('aria-hidden');

        $('.top-refinement-bar-btn').addClass('d-none');
        $('.btn.filter-results:visible').focus();
        $('html').removeClass('js-no-scroll');
        if (refinementSelected && isMobile()) {
            scrollOnApplyRefinement();
            refinementSelected = false;
            loadFlag = false;
        }
    });

    $('.refinement-bar-btn .btn-secondary.close').on('click', function () {
        if (refinementSelected && isMobile()) {
            setTimeout(function () {
                scrollOnApplyRefinement();
            }, 250);
            refinementSelected = false;
            loadFlag = false;
        }
    });

    $('.modal-background').click(function () {
        if ($('.collapse-left').hasClass('show')) {
            $('.refinement-bar button.close:visible').eq(0).click();
        }
    });
};

searchBase.closeRefinementsClickedOutside = function () {
    $('body').on('click, mousedown', function (event) {
        if ($('.refinement-bar').hasClass('show') && !$(event.target).closest('.refinement-bar').length && isMobile()) {
            $('.refinement-bar button.close').trigger('click');
        }
    });
};

function appendSkeleton(selectors) {
    return new Promise((resolve) => {
        $(selectors).each(function () {
            if (!$(this).children('.skeleton-overlay').length > 0) {
                $(this).append(`<div class='skeleton-overlay'><div class='skeleton-tile shimmer'></div></div>`); // eslint-disable-line
            }
        });

        resolve();
    });
}

searchBase.resetSortSelect = function () {
    $(document).ready(function () {
        hideSingleValueFromRefinement();
        if (isDesktop()) {
            setCustomSelectWidth();
            if (new URL(location.href).searchParams.get('filterPanelOpen') === 'true') {
                var currele = $('#filtersMenuButton');
                $('.refinements-sidebar').toggleClass('animate col-md-3 col-md-0');
                currele.toggleClass('arrow-down');
                $('.view-filter').toggleClass('col-md-9 col-12');
                var togglefilters = currele.find('.filter-text').find('.show-filters');
                togglefilters.toggleClass('d-none');
                togglefilters.siblings().toggleClass('d-none');
            }
        }
        updateSrule();
        if (isMobile()) {
            mobileFilterPanelControls();
        }
        if (performance.navigation.type === 2) {
            if ('scrollPosition' in sessionStorage) {
                var skeletonSelectors = [
                    $('.product-grid').children(),
                    $('.refinement-container'),
                    $('.js-refinements'),
                    $('.results-reset'),
                    $('.plp-header-text'),
                    $('.breadcrumb'),
                    $('.search-filter-sort-container').children(),
                    $('.plp-hero-content-asset-container'),
                    $('.plp-recomm-slot'),
                    $('.seo-category-asset'),
                    $('.plp-hero')
                ];

                $('html,body').animate({
                    scrollTop: sessionStorage.getItem('scrollPosition')
                }, 0, function () {
                    appendSkeleton(skeletonSelectors).then(function () {
                        $('#maincontent').css('visibility', 'visible');
                        $('.skeleton-overlay').fadeOut(1000, function () {
                            $(this).remove();
                        });
                    });
                });
            }
        } else {
            if ($('#maincontent').css('visibility') === 'hidden') {
                $('#maincontent').css('visibility', 'visible');
            }
            $('.skeleton-overlay').remove();
        }
    });
};

var handleResizeFiltersAndSelect = debounce(function () {
    if (isMobile() && !$('.btn.filter-results:visible').hasClass('collapsed')) {
        $('.btn.filter-results:visible').click();
    }

    $('.refinement-bar').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);

    // IMPORTANT: Ensure screen reader announcers are always accessible
    $('#refinement-announcer, #num-results-announcer').removeAttr('aria-hidden');

    setCustomSelectWidth();
}, 200);

searchBase.resize = function () {
    // Close refinement bar and hide modal background if user resizes browser
    $(window).resize(handleResizeFiltersAndSelect);
};

searchBase.resetFilter = function () {
    // This is intentionally empty
};

searchBase.sort = function () {
    // Handle sort order menu selection
    $('.search-results').on('custom-dropdown:change', '.sort-dropdown', function (e) {
        e.preventDefault();
        $.spinner().start();
        var sortLabel = $(this).find('[selected]').data('value');
        if (sortLabel !== undefined) {
            $('.num-results .placeholder').html(sortLabel);
        }
        $(this).trigger('search:sort', this.value);
        handleSortPrefix(sortLabel);
        const urlParams = new URLSearchParams(this.value);
        var selectedSortOption = urlParams.get('srule');
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value, isPageDesigner: isPageDesigner, pageId: pageDesignerId },
            method: 'GET',
            success: function (response) {
                var $productGrid = $('.product-grid');

                var updatedResponse = injectRenderedGridRegions(response);
                if (updatedResponse) {
                    var $gridRegionsToRenderClone = $('#pd-gridRegionsToRender').clone(true);
                    $productGrid.empty().html(updatedResponse);
                    $productGrid.append($gridRegionsToRenderClone);
                } else {
                    $productGrid.empty().html(response);
                }

                $('.disclaimer-info-plpbanner').addClass('d-none');
                if ($(response).filter('.grid-footer').attr('data-page-view') === 'normal') {
                    $('.disclaimer-info-plpbanner').removeClass('d-none');
                }
                common.lazyLoad();
                if (!breakpoints.isDesktopView() && $('.filter-bar ul.d-md-none').children().length > 1) {
                    updateAppliedFilter();
                }
                setURLSearchParam('srule', selectedSortOption);

                var numResultsText = $('.num-results span:visible').text();
                // Clear first, then announce after refinement-announcer (which has 100ms delay)
                $('#num-results-announcer').text('');
                setTimeout(function () {
                    $('#num-results-announcer').text(numResultsText);
                }, 400); // 400ms delay to ensure it announces after refinement-announcer

                if (breakpoints.isDesktopView()) {
                    scrollOnApplyRefinement();
                } else {
                    refinementSelected = true;
                }
                var $customDropdown = $('.custom-dropdown');
                $customDropdown.find('.display-value').removeClass('d-none');
                $('body').trigger('quickview:loadButtons');
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

searchBase.resizePageDesignerContentTiles = function () {
    $(window).on('load', function () {
        handleContentTileResize();
    });

    $(window).on('resize', function () {
        debounceHandleContentTileResize();
    });
};

searchBase.initCustomFilterButton = function () {
    $(document).on('click', '[data-custom-filter-button], [data-filter-button]', function (e) {
        if ($(this).is('a')) {
            e.preventDefault();
        }
        if ($(this).prop('disabled')) {
            return;
        }

        $.spinner().start();

        var $btn = $(this);
        var isSelected = $btn.attr('aria-pressed') === 'true';
        if (isSelected) {
            $btn.attr('aria-pressed', 'false');
        } else {
            $btn.attr('aria-pressed', 'true');
        }
        var hasResetClass = $btn.hasClass('reset');
        var selectedRefinmentParent = $(this).closest('li').data('id');

        // #5 fix: if button is already selected, clear filters (toggle off); otherwise apply
        var filterUrl = isSelected
            ? customFilterButtons.buildClearFilterUrl()
            : customFilterButtons.buildApplyFilterUrl($btn);

        if (!filterUrl) {
            $.spinner().stop();
            return;
        }

        // Update browser URL bar (the AJAX call renders new content, replaceState keeps URL in sync)
        replaceUrlAndSync(filterUrl);

        var gridRegionLastIndexObj = $('#pd-gridRegionsToRender').data('grid-region-last-index-obj');
        $.ajax({
            url: filterUrl,
            data: {
                page: $('.grid-footer').data('page-number'),
                selectedUrl: filterUrl,
                gridRegionLastIndexObj: JSON.stringify(gridRegionLastIndexObj),
                isPageDesigner: isPageDesigner
            },
            method: 'GET',
            success: function (response) {
                var $results = $(response);

                var hasProducts = $results.find('.product-grid .product-tile').length > 0;
                var noResults = $('.search-results').find('.no-search-results-container').length > 0;

                if (hasProducts) {
                    parseResults(response, noResults);
                } else {
                    $('.search-results').html($results.find('.search-results').html());
                }

                handleSortPrefix();
                var filterCount = $('.refinement-panel .refinement .refinement-input span.selected, .refinement-panel .refinement li button span.selected').length;
                if (filterCount > 0) {
                    $('.disclaimer-info-plpbanner').removeClass('d-none');
                } else {
                    $('.disclaimer-info-plpbanner').addClass('d-none');
                }

                if (isDesktop()) {
                    getFilterPanelParam();
                }
                if ($('.refinement-panel-desktop').hasClass('show')) {
                    $('.top-refinement-bar-btn').removeClass('d-none');
                }
                if (hasResetClass) {
                    $('.refinement-url-value').val('');
                } else {
                    $('.refinement-url-value').val(filterUrl);
                }
                $(document).trigger('custom:filter:buttons:updated');
                $('body').trigger('quickview:loadButtons');
                hideSingleValueFromRefinement();

                mobileFilterPanelControls();

                // Update sort
                var sortLabel = $('.container .custom-select[name=sort-order]').find(':selected').data('value');
                if (sortLabel !== undefined) {
                    $('.num-results .placeholder').html(sortLabel);
                }

                var numResultsText = $('.num-results span:visible').text();
                // Clear first, then announce after refinement-announcer (which has 100ms delay)
                $('#num-results-announcer').text('');
                setTimeout(function () {
                    $('#num-results-announcer').text(numResultsText);
                }, 400); // 400ms delay to ensure it announces after refinement-announcer

                resetSort();
                common.lazyLoad();
                if (isDesktop()) {
                    var $focusTarget = $(`.refinements li[data-id="${selectedRefinmentParent}"]`).find('.refinement-input, button');
                    if ($focusTarget.length > 0) {
                        // Store the original aria-label
                        var originalAriaLabel = $focusTarget.attr('aria-label');

                        // Temporarily set empty aria-label to suppress announcement
                        $focusTarget.attr('aria-label', '');

                        // Wait for live regions to announce (800ms), then focus
                        setTimeout(function () {
                            $focusTarget.focus();

                            // Restore original aria-label after focus
                            setTimeout(function () {
                                if (originalAriaLabel) {
                                    $focusTarget.attr('aria-label', originalAriaLabel);
                                } else {
                                    $focusTarget.removeAttr('aria-label');
                                }
                            }, 100);
                        }, 800);
                    }
                } else {
                    refinementSelected = true;
                }
            },
            complete: function () {
                scrollOnApplyRefinement();
                $.spinner().stop();
            }
        });
    });
};

module.exports = searchBase;
